import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Router from 'root/router';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';

export function createProject(name, domains, template_code) {
    Cache.app.request({
        action:  'project/create',
        data:    {
            name          : name,
            domains       : domains,
            template_code : template_code
        },
        success: (response) => {
            // add project & domain to the collection
            Cache.project_domain.add(response.project_domain);
            Cache.project.add([response.project]);

            Router.navigate('/' + response.project.project_key + '/dashboard/designer', {trigger: true});
            UI.success('Project "' + name + '" created');
        }
    });
};

var Create_Project = View.extend({
    className: 'project-create',

    template_code: '',
    domain_max: 5,

    views: {
        domain: {}
    },

    events: {
        'click .domain-add'             : 'onAddDomain',
        'click .domain-delete'          : 'onDeleteDomain',
        'focus input[name="domain"]'    : 'onFocusDomain',
        'blur input[name="domain"]'     : 'onBlurDomain',
        'mousedown .dropdown-domain li' : 'onSelectDomain',
        'keyup input[name="domain"]'    : 'onTypeDomain',
        'submit form'                   : 'submit'
    },

    dom_handlers: {
        onAddDomain: function(e) {
            $(this.getDomainTemplate()).appendTo(this.$el.find('.region-domains'));

            this.$el.find('.domain-delete').prop('disabled', false);
            this.$el.find('.domain-add').prop('disabled', this.$el.find('.region-domains > div').length >= this.domain_max);
        },

        onDeleteDomain: function(e) {
            $(e.currentTarget).parents('.multiple-input').remove();

            var length = this.$el.find('.region-domains > div').length;

            this.$el.find('.domain-delete').prop('disabled', length <= 1);
            this.$el.find('.domain-add').prop('disabled', length >= this.domain_max);
        },

        onFocusDomain: function(e) {
            var input_parent = $(e.currentTarget).parents('.multiple-input');

            this.$el.find('.dropdown-domain')
                .insertAfter(input_parent)
                .show();

            this.$el.find('.dropdown-domain li').show();

            // search to hide domains that are already entered
            input_parent.find('input[name="domain"]').keyup();
        },

        onBlurDomain: function(e) {
            // hack: let people click the dropdown
            setTimeout(() => {
                this.$el.find('.dropdown-domain').hide();
            });
        },

        onSelectDomain: function(e) {
            var domain = $(e.currentTarget).text();
            this.$el.find('.dropdown-domain').prev('.multiple-input').find('input[name="domain"]').val(domain);
            this.$el.find('.dropdown-domain').hide();
        },

        onTypeDomain: function(e) {
            var domains = this.getDomains();
            var search = $(e.currentTarget).val();
            var found = false;

            this.$el.find('.dropdown-domain li').each(function() {
                var domain = $(this).text().toLowerCase();

                if (domain.indexOf(search) === -1 || domains.indexOf(domain) !== -1) {
                    $(this).hide();
                } else {
                    $(this).show();
                    found = true;
                }
            });

            this.$el.find('.dropdown-domain').toggle(found);
        },

        submit: function(e) {
            e.preventDefault();

            if (Cache.account.getProjectLimit() <= Cache.project.where({is_archived: false}).length) {
                return;
            }

            var form_data = Form.getData(this.$el.find('form'));
            var domains   = Util.arrayUnique(this.getDomains());

            this.$el.find('button:submit').addClass('loading').prop('disabled', true);

            createProject(form_data.name, domains, this.template_code);

            // tracking onboarding
            if (this.template_code.startsWith('wt')) {
                Cache.app.trackOnboarding('create_project_feedback', '1');
            } else {
                Cache.app.trackOnboarding('create_project_survey', '1');
            }
        }
    },

    initialize: function(template_code) {
        this.template_code = template_code;

        // get project type from template code
        // if template code first 2 charactor with su is survey, start with wt is widget
        this.project_type = template_code.substring(0, 2) === 'su' ? 'survey' : 'feedback';
    },

    focus: function() {
        this.$el.find('form input[name="name"]').focus();
    },

    getDomains: function() {
        var domains = [];

        this.$el.find('.region-domains input[type="text"]').each(function() {
            var domain = $(this).val();

            if (domain) {
                domains.push(domain);
            }
        });

        return Util.arrayUnique(domains);
    },

    getDomainTemplate: function() {
        var template =
        '<div class="multiple-input">' +
            '<div><button type="button" class="domain-delete text-icon"><i class="fa-solid fa-circle-minus"></i></button></div>' +
            '<div>' +
                '<div class="input-domain-small">' +
                    '<input type="text" name="domain" maxlength="150" placeholder="app.mycompany.com" required>' +
                '</div>' +
            '</div>' +
        '</div>';

        return template;
    },

    render: function() {
        var domain_options = '';

        // get unique domains
        var project_domains = [];
        Cache.project_domain.each((model) => {
            if (project_domains.indexOf(model.escape('domain')) === -1) {
                project_domains.push(model.escape('domain'));
            }
        });

        // build dropdown options
        project_domains.forEach((domain) => {
            domain_options += '<li>' + domain + '</li>';
        });

        var content =
        '<h1 class="text-align-center margin-bottom-42"><b>Create a new project</b></h1>' +
        '<form class="form-fluid margin-bottom-24">' +
            '<div class="row">' +
                '<div class="field-label">Project name</div>' +
                '<input type="text" class="solid compact" name="name" maxlength="100" placeholder="My Web App" data-nonempty="true" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Project domain</div>' +
                '<div class="text-info text-medium">This is where the Userback code will be installed</div>' +

                '<div class="region-domains">' +
                    (domain_options ?
                    '<ul class="dropdown dropdown-domain">' + domain_options + '</ul>' : '') +
                    this.getDomainTemplate() +
                '</div>' +
                '<div class="divider-12"></div>' +
                '<button type="button" class="domain-add text-info-small" data-theme="' + this.project_type + '"><i class="fa-solid fa-circle-plus"></i>Add domain</button>' +
            '</div>' +

            '<div class="margin-top-48">' +
                '<button type="submit" class="primary medium full" data-theme="' + this.project_type + '">Create</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        this.$el.find('.domain-delete').prop('disabled', true);

        return this;
    }
});

export default Create_Project;
